import { API_PATH } from '@/shared/constants/api'
import { apiRequest } from '@/shared/helpers/api-request'
import type { RentersPolicy } from '@/shared/types/global.types'

export type TemporaryUploadModel = {
  id: number
  url: string
  blobType: string
}

export function getRentersPolicy(token: string): Promise<RentersPolicy[]> {
  return apiRequest<RentersPolicy[]>(API_PATH.RENTERS_POLICY, token)
}

export type AdditionalPartyPayload = {
  type: 'Spouse' | 'roommate' | 'pet'
  name: string
  email?: string
  pet_type?: string
  pet_birth_date?: string
  breed_id?: number
}

export async function postAdditionalParties(
  token: string,
  policyId: string,
  body: AdditionalPartyPayload[],
): Promise<void> {
  await apiRequest<void>(
    `${API_PATH.RENTERS_POLICY}/${policyId}${API_PATH.ADDITIONAL_PARTIES_NOTIFY}`,
    token,
    'POST',
    body,
  )
}

export function getTemporaryUploadUrl(
  token: string,
  fileExtension: string,
): Promise<TemporaryUploadModel> {
  return apiRequest<TemporaryUploadModel>(
    `${API_PATH.TEMPORARY_FILE_UPLOAD_URL}?fileExtension=${encodeURIComponent(fileExtension)}`,
    token,
  )
}

export async function uploadVideoToAzure(
  url: string,
  blobType: string,
  file: File,
): Promise<void> {
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'x-ms-blob-type': blobType,
      'Content-Type': 'application/octet-stream',
    },
    body: file,
  })
  if (!response.ok) {
    throw new Error(`Azure upload failed: ${response.status}`)
  }
}
